export default __webpack_public_path__ + "static/xtaas-f5813a35e24ef96fb516cf079f819622.svg";